import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const TOestagio = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const condicional = useSelector((state) => state.addForm.modulos)
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if(ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="ESTÁGIO OBRIGATÓRIO" />
                    <div style={{ textAlign: "left" }}>
                        <Select label="Estágio Obrigatório" nome="toobrigatorio" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="13vw" widthMobile="80vw" marginR="2vw"
                            array={["Sim", "Não"]} />

                        {RenderCondicional()}
                    </div>

                    <HeaderVerde texto="ESTÁGIO NÃO OBRIGATÓRIO" />
                    <div style={{ textAlign: "left" }}>
                        <Select label="Estágio Não Obrigatório" nome="tonaoobrigatorio" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="13vw" widthMobile="80vw" marginR="2vw"
                            array={["Sim", "Não"]} />

                        {RenderCondicional2()}

                    </div>
                    <HeaderVerde texto="ESTAGIÁRIOS" />
                    <div style={{ textAlign: "left" }}>
                        <Input label="Quantidade de Estagiário" nome="toestagiarioqtd" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />

                        {RenderCondicional3()}
                    </div>
                </Caixa>
            )

            function RenderCondicional() {
                let campos = []
                if (condicional[modulo].length > 0) var array = condicional
                else var array = ficha
                var quantidade = array[modulo][n]["toobrigatorio"]
                if (array[modulo][n]["toobrigatorio"] === "Sim") {
                    campos.push(
                        <>
                            <Select label="Termo de Compromisso de Estágio" nome="tocompromissoobg" modulo={modulo} index={n}
                                widthWeb="13vw" widthMobile="80vw" marginR="3vw"
                                array={["Sim", "Não"]} />
                            {/* <Select label="Relação Nominal dos Supervisores/Docentes" nome="torelacaonominalobg" modulo={modulo} index={n}
                                widthWeb="13vw" widthMobile="80vw" marginR="3vw"
                                array={["Sim", "Não"]} /> */}
                            <HeaderVerde texto="Legalidade" />
                            <Select label="Conformidade com a Resolução COFFITO 451/15" nome="resolucao431" modulo={modulo} index={n}
                                widthWeb="13vw" widthMobile="80vw" marginR="3vw"
                                array={["Sim", "Não"]} />

                        </>
                    )
                }

                return campos
            }
            function RenderCondicional2() {
                let campos = []
                if (condicional[modulo].length > 0) var array = condicional
                else var array = ficha
                var quantidade = array[modulo][n]["tonaoobrigatorio"]
                if (array[modulo][n]["tonaoobrigatorio"] === "Sim") {
                    campos.push(
                        <>
                            <Select label="Termo de Compromisso de Estágio" nome="tocompromisso" modulo={modulo} index={n}
                                widthWeb="13vw" widthMobile="80vw" marginR="2vw"
                                array={["Sim", "Não"]} />
                            {/* <Select label="Relação Nominal dos Preceptores e Docentes" nome="torelacaonominal" modulo={modulo} index={n}
                                widthWeb="13vw" widthMobile="80vw" marginR="2vw"
                                array={["Sim", "Não"]} /> */}

                            <HeaderVerde texto="Legalidade" />
                            <Select label="Conformidade com a Resolução COFFITO 452/15" nome="resolucao452" modulo={modulo} index={n}
                                widthWeb="13vw" widthMobile="80vw" marginR="2vw"
                                array={["Sim", "Não"]} />

                        </>
                    )
                }
                return campos
            }
            function RenderCondicional3() {
                let campos = []
                if (condicional[modulo].length > 0) var array = condicional
                else var array = ficha
                var quantidade = array[modulo][n]["toestagiarioqtd"]
                if (array[modulo][n]["toestagiarioqtd"]) {
                    for (let i = 0; i < quantidade; i++) {
                        campos.push(
                            <div>
                                <Input label="Acadêmico" nome="toacademico" modulo={modulo} index={n} subModulo="toacademico" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="57vw" widthMobile="80vw" marginR="3vw" />

                                <Input label="RG" nome="torg" modulo={modulo} index={n} subModulo="torg" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="12vw" widthMobile="80vw" marginR="3vw" />

                                <Input label="CPF" nome="tocpf" modulo={modulo} index={n} subModulo="tocpf" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="12vw" widthMobile="80vw" marginR="3vw" />

                                <Input label="IES" nome="toies" modulo={modulo} index={n} subModulo="toies" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="12vw" widthMobile="80vw" marginR="3vw" />

                                <Input label="Período do Curso" nome="toperiodocurso" modulo={modulo} index={n} subModulo="toperiodocurso" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="12vw" widthMobile="80vw" marginR="3vw" />

                                <Select label="Modalidade do Estágio" nome="tomodalidade" modulo={modulo} index={n} subModulo="tomodalidade" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="12vw" widthMobile="80vw" marginR="3vw"
                                    array={["Obrigatório", "Não Obrigatório"]} />

                                <Select label="Dispõe de crachá fornecido pelo Crefito 1" nome="toresponsavel" modulo={modulo} index={n} subModulo="toresponsavel" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="19vw" widthMobile="80vw" marginR="3vw"
                                    array={["Sim", "Não", "Não se Aplica"]} />
                            </div>
                        )
                    }
                }
                return campos
            }
        }
        return partes
    }
}
export default TOestagio